// The Generic Switch reading is a 12-bit field containing two 6-bit values. The first value is the number of switch closures in the reading period. The second value is the number of switch samples in the reading period. These values are used to create a switch closure percentage value. Convert the 12-bit value ($rdg in code below) to percent ($pct in code below) using the following algorithm:

/*
$pct = 0.0;
if ( $rdg == 0xFFF )
{
  $pct = null; // display reading as “invalid”
}
else
{
  $cls = ((int)$rdg) >> 6;
  $clk = ((int)$rdg) & 0x3F;
  $pct = $cls * 100.0 / (float)$clk;
  if ( $pct > 100.0 ) {
    $pct = 100.0;
  }
}
*/

export function genericSwitch(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  const closure = reading >> 6
  const clock = reading & 0x3f
  var percent = (closure * 100.0) / clock

  if (percent > 100.0) {
    percent = 100.0
  }
  return percent
}
